const s=s=>{switch(s){case"info":case"info-without-shadow":case"error":return"info-painted";case"success":return"success";case"danger":return"cross-in-circle"}};export{s as getIconName};
